<div *ngIf="displayed" class="dialog-body">
  <ng-container [ngTemplateOutlet]="dialogTemplate"></ng-container>
</div>
<div *ngIf="displayed" class="modal-background"></div>
